export const createInvoice = `
    mutation createInvoice($input: CreateInvoiceInput!) {
        createInvoice(input:$input) {
            id
            customerId
            invoiceUrl
    }
}`;

export const updateInvoice = `
    mutation updateInvoice($input: UpdateInvoiceInput!) {
        updateInvoice(input:$input){
            id
            customerId
            invoiceUrl
        }
}`;

export const deleteInvoice = `
    mutation deleteInvoice($input: DeleteInvoiceInput!) {
        deleteInvoice(input:$input)
}`;
